import {
  FETCH_FTPFOLDERS_BEGIN,
  FETCH_FTPFOLDERS_SUCCESS,
  FETCH_FTPFOLDERS_FAILURE,
  FETCH_USERFOLDERS_BEGIN,
  FETCH_USERFOLDERS_SUCCESS,
  FETCH_USERFOLDERS_FAILURE,
  SET_AUTHFOLDERS,
  SAVE_USERFOLDERS_BEGIN,
  SAVE_USERFOLDERS_SUCCESS,
  SAVE_USERFOLDERS_FAIL,
  CREATE_FOLDER_BEGIN,
  CREATE_FOLDER_SUCCESS,
  CREATE_FOLDER_FAIL,
  DELETE_FOLDER_BEGIN,
  DELETE_FOLDER_SUCCESS,
  DELETE_FOLDER_FAIL,
  TOGGLE_CREATE_FOLDER,
  TOGGLE_DELETE_FOLDER,
  CLEAR_MESSAGE,
  SELECT_FOLDER,
  DESELECT_FOLDER

} from '../action/ftpFolderActions'


import { GET_LOGGED_IN_USER_BEGIN, GET_LOGGED_IN_USER_SUCCESS, GET_LOGGED_IN_USER_FAIL } from '../../AcctMgt/action/userActions'



const initialState = {
  tree: null,
  loading: false,
  error: null,
  userTree: null,
  authKeys: [],
  newAuthKeys: [],
  ioMessage: null,
  showDelete: false,
  showCreate: false,
  userInfo: null,
  selectedFolder: { props: {} }
};

function getKeys(oldKeys, newKeys) {
  oldKeys.forEach(old => {
    var parentExists = newKeys.filter(k => {
      //  console.log(`if ${old} starts with`)
      return old.startsWith(k + '\\')
    })
    if (parentExists.length == 0) {
      newKeys.push(old)
    }

  })
}


export default function ftpFolderReducer(
  state = initialState,
  action
) {
  switch (action.type) {

    case SELECT_FOLDER:
      return {
        ...state,
        selectedFolder: action.payload.folder
      }

    case DESELECT_FOLDER:
      return {
        ...state,
        selectedFolder: { props: {} }
      }

    case GET_LOGGED_IN_USER_BEGIN:
      return {
        ...state,
        loading: true
      }

    case GET_LOGGED_IN_USER_SUCCESS:
      return {
        ...state,
        userInfo: action.payload.result
      }
    case GET_LOGGED_IN_USER_FAIL:
      return {
        ...state,
        error: action.payload.error
      }

    case CLEAR_MESSAGE:
      return { ...state, ioMessage: null }

    case TOGGLE_CREATE_FOLDER:
      return {
        ...state,
        showCreate: !state.showCreate
      }

    case TOGGLE_DELETE_FOLDER:
      return {
        ...state,
        showDelete: !state.showDelete
      }

    case CREATE_FOLDER_BEGIN:
      return {
        ...state,
        loading: true,
        ioMessage: null
      }
    case CREATE_FOLDER_SUCCESS:
      return {
        ...state,
        loading: false,
        userTree: [action.payload.result.tree],
        //authKeys : action.payload.result.authKeys,
        //  newAuthKeys : action.payload.result.authKeys,
        ioMessage: action.payload.result.message
      }

    case CREATE_FOLDER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      }

    case DELETE_FOLDER_BEGIN:
      return {
        ...state,
        loading: true,
        ioMessage: null
      }
    case DELETE_FOLDER_SUCCESS:
      return {
        ...state,
        loading: false,
        userTree: [action.payload.result.tree],
        //  authKeys : action.payload.result.authKeys,
        //    newAuthKeys : action.payload.result.authKeys,
        ioMessage: action.payload.result.message
      }

    case DELETE_FOLDER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      }

    case SAVE_USERFOLDERS_BEGIN:
      return {
        ...state,
        loading: true,
      }


    case SAVE_USERFOLDERS_SUCCESS:

      return {
        ...state,
        userTree: [action.payload.result.tree],
        authKeys: action.payload.result.authKeys,
        newAuthKeys: action.payload.result.authKeys,
        loading: false
      }

    case SAVE_USERFOLDERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      }

    case SET_AUTHFOLDERS:

      let treeKeys = action.payload.node
      treeKeys.sort()
      let newAuthKeys = []

      var hiddenFilter = treeKeys.filter(t => {
        return t.includes('|hidden|')
      })

      hiddenFilter.forEach(f => {
        var index = treeKeys.indexOf(f)
        if (index != -1) {
          treeKeys.splice(index, 1)
        }
      })

      getKeys(treeKeys, newAuthKeys)

      console.log('new keys', newAuthKeys)


      return {
        ...state,
        newAuthKeys
      }
    case FETCH_FTPFOLDERS_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_FTPFOLDERS_SUCCESS:
      // All done: set loading "false".
      // Also, replace the groups with the ones from the server

      return {
        ...state,
        loading: false,
        tree: [action.payload.tree]
      };

    case FETCH_FTPFOLDERS_FAILURE:
      // The request failed, but it did stop, so set loading to "false".
      // Save the error, and we can display it somewhere
      // Since it failed, we don't have groups to display anymore, so set it empty.
      // This is up to you and your app though: maybe you want to keep the groups
      // around! Do whatever seems right.
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        tree: null
      };


    case FETCH_USERFOLDERS_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_USERFOLDERS_SUCCESS:
      // All done: set loading "false".
      // Also, replace the groups with the ones from the server
      return {
        ...state,
        loading: false,
        userTree: [action.payload.tree.tree],
        authKeys: action.payload.tree.authKeys,
        newAuthKeys: action.payload.tree.authKeys
      };

    case FETCH_USERFOLDERS_FAILURE:
      // The request failed, but it did stop, so set loading to "false".
      // Save the error, and we can display it somewhere
      // Since it failed, we don't have groups to display anymore, so set it empty.
      // This is up to you and your app though: maybe you want to keep the groups
      // around! Do whatever seems right.
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        userTree: null,
        authKeys: []
      };


    default:
      return state
  }
}
